import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { CardSelectorSkeleton } from "@components/common/skeleton-loading/card-selector-skeleton";
import { CardSelector, Text, EmptyIcon, Divider } from "@flat-ui";
import { useCreditPackages } from "@hooks/use-credit-packages";
import { Grid, Stack } from "@mui-wrapper";
import { CreditFeatureItem } from "@pages/settings/subscription-settings/credits/credit-feature-item";
import { CreditPurchase } from "@pages/settings/subscription-settings/credits/credit-purchase";
import { RequestCreditQuote } from "@pages/settings/subscription-settings/credits/request-credit-quote";
import { CREDIT_DISPLAY_NAME, CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { convertCreditPackagesToCardItems, formatCreditPackagePrice } from "@utils/credit-package-utils";

/** List of credit-related features */
const CREDIT_FEATURES = [`Use ${CREDITS_DISPLAY_NAME} to generate floorplans`, `Purchase ${CREDITS_DISPLAY_NAME} tailored to your needs`, `Use ${CREDITS_DISPLAY_NAME} within 12 months`];
/** Render the credit packages list for purchasing credits. */
export function CreditPackages(t0) {
  const $ = _c(78);
  const {
    selectedPackage,
    setSelectedPackage
  } = t0;
  const {
    fetchSelectedCompanyContext,
    fetchCompanySubscriptions
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const {
    creditPackages,
    isLoading: isLoadingPackages
  } = useCreditPackages();
  let t1;
  if ($[0] !== creditPackages) {
    t1 = convertCreditPackagesToCardItems(creditPackages);
    $[0] = creditPackages;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cardItems = t1;
  let T0;
  let T1;
  let T2;
  let T3;
  let activePackage;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== cardItems || $[3] !== creditPackages || $[4] !== fetchCompanySubscriptions || $[5] !== fetchSelectedCompanyContext || $[6] !== isLoadingPackages || $[7] !== selectedPackage?.id || $[8] !== setSelectedPackage) {
    t16 = Symbol.for("react.early_return_sentinel");
    bb0: {
      activePackage = isLoadingPackages ? undefined : creditPackages.find(t17 => {
        const {
          id
        } = t17;
        return id === selectedPackage?.id;
      });
      const isLoading = isLoadingPackages || fetchSelectedCompanyContext === "pending" || fetchCompanySubscriptions === "pending";
      if (cardItems.length === 0 && !isLoadingPackages) {
        let t18;
        if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
          t18 = <EmptyPage title={`No ${CREDIT_DISPLAY_NAME} packages available`} subtitle="Please check back later or contact support for assistance." icon={EmptyIcon} />;
          $[29] = t18;
        } else {
          t18 = $[29];
        }
        t16 = t18;
        break bb0;
      }
      let t18;
      if ($[30] !== creditPackages || $[31] !== setSelectedPackage) {
        t18 = function handleOnSelect(productId) {
          const creditPackage = creditPackages.find(t19 => {
            const {
              id: id_0
            } = t19;
            return id_0 === productId;
          });
          if (creditPackage) {
            setSelectedPackage(creditPackage);
          }
        };
        $[30] = creditPackages;
        $[31] = setSelectedPackage;
        $[32] = t18;
      } else {
        t18 = $[32];
      }
      const handleOnSelect = t18;
      if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = <Stack sx={{
          alignItems: "center",
          marginTop: {
            sm: "0px",
            md: "50px"
          },
          marginBottom: "50px"
        }}><Text variant="heading24"> Add {CREDITS_DISPLAY_NAME}</Text><Text variant="bodyM">Select the {CREDIT_DISPLAY_NAME} package that best fits your needs.</Text></Stack>;
        $[33] = t15;
      } else {
        t15 = $[33];
      }
      T3 = Grid;
      t12 = true;
      if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {
          marginX: "auto",
          width: {
            lg: "70%"
          }
        };
        $[34] = t13;
      } else {
        t13 = $[34];
      }
      let t19;
      if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = {
          xs: 12,
          sm: 6,
          md: 6,
          lg: 6,
          xl: 6
        };
        $[35] = t19;
      } else {
        t19 = $[35];
      }
      const t20 = isLoading ? <CardSelectorSkeleton /> : <CardSelector cardDirection="column" cardItems={cardItems} selectedValue={activePackage?.id} onSelect={handleOnSelect} />;
      if ($[36] !== t20) {
        t14 = <Grid component="div" size={t19}><Stack>{t20}</Stack></Grid>;
        $[36] = t20;
        $[37] = t14;
      } else {
        t14 = $[37];
      }
      T2 = Grid;
      t10 = "div";
      if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
          xs: 12,
          sm: 6,
          md: 6,
          lg: 6,
          xl: 6
        };
        $[38] = t11;
      } else {
        t11 = $[38];
      }
      T1 = Stack;
      if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
          backgroundColor: "surfaces.secondary",
          borderRadius: "4px",
          marginTop: {
            xs: "15px",
            sm: "0px"
          },
          marginLeft: {
            xs: "0px",
            sm: "15px"
          },
          padding: "32px"
        };
        t6 = <Text variant="heading16">Check out</Text>;
        $[39] = t5;
        $[40] = t6;
      } else {
        t5 = $[39];
        t6 = $[40];
      }
      if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <Divider sx={{
          marginY: "12px"
        }} />;
        t8 = CREDIT_FEATURES.map(_temp);
        $[41] = t7;
        $[42] = t8;
      } else {
        t7 = $[41];
        t8 = $[42];
      }
      if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <Divider sx={{
          marginY: "12px"
        }} />;
        $[43] = t9;
      } else {
        t9 = $[43];
      }
      T0 = Stack;
      if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "24px"
        };
        t3 = <Text variant="bodyM">Total</Text>;
        $[44] = t2;
        $[45] = t3;
      } else {
        t2 = $[44];
        t3 = $[45];
      }
      t4 = activePackage && <Text variant="bodyM"><var>{formatCreditPackagePrice(activePackage.priceInCents)}</var></Text>;
    }
    $[2] = cardItems;
    $[3] = creditPackages;
    $[4] = fetchCompanySubscriptions;
    $[5] = fetchSelectedCompanyContext;
    $[6] = isLoadingPackages;
    $[7] = selectedPackage?.id;
    $[8] = setSelectedPackage;
    $[9] = T0;
    $[10] = T1;
    $[11] = T2;
    $[12] = T3;
    $[13] = activePackage;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    T0 = $[9];
    T1 = $[10];
    T2 = $[11];
    T3 = $[12];
    activePackage = $[13];
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
    t15 = $[19];
    t16 = $[20];
    t2 = $[21];
    t3 = $[22];
    t4 = $[23];
    t5 = $[24];
    t6 = $[25];
    t7 = $[26];
    t8 = $[27];
    t9 = $[28];
  }
  if (t16 !== Symbol.for("react.early_return_sentinel")) {
    return t16;
  }
  let t17;
  if ($[46] !== T0 || $[47] !== t2 || $[48] !== t3 || $[49] !== t4) {
    t17 = <T0 sx={t2}>{t3}{t4}</T0>;
    $[46] = T0;
    $[47] = t2;
    $[48] = t3;
    $[49] = t4;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  let t19;
  if ($[51] !== activePackage) {
    t18 = <CreditPurchase selectedPackage={activePackage} />;
    t19 = <RequestCreditQuote selectedPackage={activePackage} />;
    $[51] = activePackage;
    $[52] = t18;
    $[53] = t19;
  } else {
    t18 = $[52];
    t19 = $[53];
  }
  let t20;
  if ($[54] !== T1 || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== t5 || $[59] !== t6 || $[60] !== t7 || $[61] !== t8 || $[62] !== t9) {
    t20 = <T1 sx={t5}>{t6}{t7}{t8}{t9}{t17}{t18}{t19}</T1>;
    $[54] = T1;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
    $[58] = t5;
    $[59] = t6;
    $[60] = t7;
    $[61] = t8;
    $[62] = t9;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  let t21;
  if ($[64] !== T2 || $[65] !== t10 || $[66] !== t11 || $[67] !== t20) {
    t21 = <T2 component={t10} size={t11}>{t20}</T2>;
    $[64] = T2;
    $[65] = t10;
    $[66] = t11;
    $[67] = t20;
    $[68] = t21;
  } else {
    t21 = $[68];
  }
  let t22;
  if ($[69] !== T3 || $[70] !== t12 || $[71] !== t13 || $[72] !== t14 || $[73] !== t21) {
    t22 = <T3 container={t12} sx={t13}>{t14}{t21}</T3>;
    $[69] = T3;
    $[70] = t12;
    $[71] = t13;
    $[72] = t14;
    $[73] = t21;
    $[74] = t22;
  } else {
    t22 = $[74];
  }
  let t23;
  if ($[75] !== t15 || $[76] !== t22) {
    t23 = <>{t15}{t22}</>;
    $[75] = t15;
    $[76] = t22;
    $[77] = t23;
  } else {
    t23 = $[77];
  }
  return t23;
}
function _temp(text, index) {
  return <CreditFeatureItem key={index} featureText={text} />;
}